// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zj40","colMin":"styles_colMin__3rkrK"};